import { Button } from 'antd'
import FilterPill from '../FilterPill'
import './index.scss'

interface AppliedFiltersProps {
    pills: { 
        key: string; 
        label: string; 
        value?: string;
        onClick?: () => void;
    }[];
    handleClearFilters: () => void;
    handleRemoveFilter?: (key: string) => void;
}

export default function AppliedFilters({
    pills,
    handleClearFilters,
    handleRemoveFilter 
}: AppliedFiltersProps) {
    return (
        <div className="applied-filters-wrapper">
            <p className="filter-label">Filters:</p>
            {pills.map((pill) => (
                <FilterPill 
                    key={pill.key} 
                    name={pill.label} 
                    onRemove={() => handleRemoveFilter?.(pill.key)} 
                    value={pill?.value}
                    onClick={pill.onClick}
                />
            ))}
            <Button className="clear-filter-button" onClick={handleClearFilters}>Clear All</Button>
        </div>
    )
}
